import { render, staticRenderFns } from "./Vlog.vue?vue&type=template&id=1c98aab2&scoped=true"
import script from "./Vlog.vue?vue&type=script&lang=js"
export * from "./Vlog.vue?vue&type=script&lang=js"
import style0 from "./Vlog.vue?vue&type=style&index=0&id=1c98aab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98aab2",
  null
  
)

export default component.exports